export default __webpack_public_path__ + "static/media/logout.6adddf1f.svg";